import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.25 11.0859H3.75V22.0859H20.25V11.0859Z",
      stroke: "#B29C72",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.41406 11.0846V6.5013C7.41406 3.97 9.46609 1.91797 11.9974 1.91797C14.5287 1.91797 16.5807 3.97 16.5807 6.5013V11.0846",
      stroke: "#B29C72",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 14.75V18.4167",
      stroke: "#B29C72",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }